import PlayerRankingFilter from "./PlayerRankingFilter";

const PlayerRankingFilterContainer: React.FC = () => {
  return <PlayerRankingFilter />;
};

export default PlayerRankingFilterContainer;
